export const legacyTransitionTypesMap = {
	outIn: 'OutIn',
	crossfade: 'CrossFade',
	shrinkfade: 'CrossFade',
	swipeHorizontal: 'SlideHorizontal',
	swipeHorizontalFullScreen: 'SlideHorizontal',
	swipeVertical: 'SlideVertical',
	swipeVerticalFullScreen: 'SlideVertical',
	none: 'NoTransition',
} as const
